import BaseApi from './BaseApi'

class SpasmService extends BaseApi {
  async list({dependentId, happenedAt}) {
    const params = {dependent_id: dependentId, happened_at: happenedAt}
    return this.axios.get('/v1/spasms/', {params})
  }

  async create({dependentId, happenedAt, context, spasm_type}) {
    const data = {
      dependent: dependentId,
      happened_at: happenedAt,
      context: context,
      spasm_type: spasm_type
    }

    return this.doRequest('post', '/v1/spasms/', data)
  }

  async update({spasmId, dependentId, happenedAt, context, spasm_type}) {
    const path = `/v1/spasms/${spasmId}/`
    const data = {
      dependent_id: dependentId,
      happened_at: happenedAt,
      context: context,
      spasm_type: spasm_type
    }

    return this.doRequest('patch', path, data)
  }

  async delete(spasmId) {
    const path = `/v1/spasms/${spasmId}/`

    return this.axios.delete(path)
  }

  async getMetrics(dependentId, since=null) {
    let path = `/v1/dependents/${dependentId}/spasms`
    if (since) {
      path = `${path}?happened_at=${since}`
    }
    return this.axios.get(path)
  }

  async getMetricsByHour(dependentId, since=null) {
    let path = `/v1/dependents/${dependentId}/spasms-by-hour`
    if (since) {
      path = `${path}?happened_at=${since}`
    }
    return this.axios.get(path)
  }

  async getMetricsByPeriod(dependentId, since=null) {
    let path = `/v1/dependents/${dependentId}/spasms-by-period`
    if (since) {
      path = `${path}?happened_at=${since}`
    }
    return this.axios.get(path)
  }

  async getMetricsByType(dependentId, since=null) {
    let path = `/v1/dependents/${dependentId}/spasms-by-type`
    if (since) {
      path = `${path}?happened_at=${since}`
    }
    return this.axios.get(path)
  }

  async getSpasmTypes(dependentId) {
    const path = `/v1/spasms/types/?dependent_id=${dependentId}`
    return this.axios.get(path)
  }

  async createSpasmType(data) {
    const path = '/v1/spasms/types/'
    return this.doRequest('post', path, data)
  }

  async updateSpasmType(id, data) {
    const path = `/v1/spasms/types/${id}/`
    return this.doRequest('patch', path, data)
  }

  async deleteSpasmType(id) {
    const path = `/v1/spasms/types/${id}/`
    return this.axios.delete(path)
  }
}

export default SpasmService
